const sectionTitleRowSx = { px: 2, py: 1.25, borderBottom: '1px solid', borderColor: 'divider', bgcolor: 'grey.50', display: 'flex', alignItems: 'center', justifyContent: 'space-between', }
const fieldLabelSx = { fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5, color: 'text.secondary', display: 'block', mb: 0.75, }
const toggleGroupSx = {
    flexWrap: 'wrap',
    '& .MuiToggleButton-root': {
        textTransform: 'none', fontSize: 11,
        py: 0.5, px: 1.25,
        color: 'text.secondary',
        '&.Mui-selected': { bgcolor: 'primary.main', color: 'white', '&:hover': { bgcolor: 'primary.dark' } },
        '&.Mui-disabled:not(.Mui-selected)': { opacity: 0.35 },
        '&.Mui-disabled': { cursor: 'not-allowed !important', pointerEvents: 'auto !important' },
        '&.Mui-disabled.Mui-selected': { opacity: 0.6, bgcolor: 'primary.main', color: 'white' },
    },
}
const autoFilledInputSx = {
    '& .MuiInputBase-root': { bgcolor: '#f0fdf4' },
    '& .MuiOutlinedInput-notchedOutline': { borderColor: '#a7f3d0' },
}

export { sectionTitleRowSx, fieldLabelSx, toggleGroupSx, autoFilledInputSx }